import api from './api';

export const sendFrontendLog = async (level: string, message: string, meta: any) => {
  try {
    await api.post('/logs/frontend', { level, message, meta });
  } catch (error) {
    console.error('Failed to send frontend log to backend:', error);
  }
};

export const getAdminLogs = async (filename: string = 'application', lines: number = 100, level?: string) => {
  try {
    const response = await api.get('/admin/logs', {
      params: { filename, lines, level }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch admin logs from backend:', error);
    throw error;
  }
};
